const $productSelect = $('.js-product-main-select');

$('.js-product-main-select').on('change', function() {
  const $this = $(this);
  const $option = $this.find('option:selected');
  const value = $option.val();

  const $targetSlide = $('.product__thumbs').find(`[data-variants="${value}"]`).closest('.slick-slide');

  if ($targetSlide.length > 0) {
    $targetSlide.trigger('click');
  }
});
